<template>
   <el-tabs type="border-card">
    <el-tab-pane label="产品汇率配置列表">
      <div style="margin-top:16px;" >
        <el-form :inline="true" :model="companyForm" class="demo-form-inline">
          <el-form-item label="产品汇率">
            <el-input v-model.trim="companyForm.name" placeholder="产品汇率"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="mini" @click="onSubmit" icon="el-icon-search">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div style="margin-top:10px;">
        <el-table
          :data="data"
          border>
          <el-table-column
            prop="id"
            label="ID编号"
            width="100">
          </el-table-column>
          <el-table-column
            prop="name"
            width="260"
            show-overflow-tooltip
            label="汇率名称">
          </el-table-column>
          <el-table-column
            prop="rate"
            show-overflow-tooltip
            label="实时汇率">
          </el-table-column>
          <el-table-column
            prop="realTax"
            show-overflow-tooltip
            label="当前税金">
          </el-table-column>
          <el-table-column
            prop="realRate"
            show-overflow-tooltip
            label="最终汇率">
          </el-table-column>
          <el-table-column
            width="240"
            prop="createDate"
            label="创建时间">
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            width="160">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="handleEdit(scope.row)">编辑</el-button>
            </template>
        </el-table-column>
        </el-table>
      </div>
    </el-tab-pane>
   </el-tabs>
</template>
<script>
import pagination from "../../../common/util/pagination";
export default {
  data() {
    return {
      data: [],
      companyForm: {
        name: '',
        token: this.user.getToken()
      },
      pagination: {
        pageSize: 10,
        pageNum: 1,
        pageTotal: 0
      }
    };
  },
  components: {
    pagination
  },
  mounted: function() {
    this.getExchangeConfigList()
  },
  methods: {
    getExchangeConfigList: function() {
      this.optionItem = this.common.extend(this.companyForm, this.pagination)
      // 初始化默认加载菜单
      this.http.post(
        '/shopConfigExchange/list',
        this.optionItem, res => {
          if (res.success) {
            // 返回正确的处理
            this.data = res.datas.data
          } else {
            // 返回错误的处理
            this.$message.error(res.message)
          }
      });
    },
    handleEdit: function(row) {
      this.$router.push({name:'exchangeConfigEditor',params:row})
    },
    onSubmit: function() {
      this.getExchangeConfigList()
    },
  }
};
</script>


<style>
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
</style>


// WEBPACK FOOTER //
// src/components/views/system/exchange/exchangeConfigList.vue